<template>
  <div class="content">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-lg-3 col-sm-12">
                <base-button outline type="primary" block @click="onBack()">
                  <span class="btn-inner--icon">
                    <i class="ni sign-left"></i>
                  </span>
                  Back to main page</base-button
                >
              </div>
            </div>

            <h3 class="mb-0 mt-4">Schedule</h3>
            <p class="text-sm mb-0">Agenda</p>
          </template>
          <div class="row card-body">
            <div class="col-lg-2">
              <base-input label="Start date">
                <flat-picker
                  class="form-control datepicker"
                  :config="{ allowInput: true }"
                  v-model="filter.start"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input label="End date">
                <flat-picker
                  :config="{ allowInput: true, minDate: filter.start }"
                  class="form-control datepicker"
                  v-model="filter.end"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-1 col-sm-12">
              <base-button type="primary" block @click.prevent="onGo"
                >Go</base-button
              >
            </div>

            <div class="col-lg-12">
              <schedule-item
                v-for="item in gsched"
                :key="item.date"
                :date="item.date"
                :items="item.items"
              ></schedule-item>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import { nophoto } from "../../../services/user";
import { DateToString } from "../../../services/helper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetScheduleByStudent } from "../../../services/classes";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ScheduleItem from "./ScheduleItem";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    flatPicker,
    ScheduleItem,
  },
  data() {
    return {
      tableData: [],
      sched: [],
      gsched: [],
      groupsched: [],
      filter: {
        start: new Date(),
        end: new Date(),
        searchtype: 1,
        studentid: this.$store.state.user.id,
        id: "",
      },
      endDate: null,
      isLoading: false,
    };
  },
  methods: {
    onBack() {
      this.$router
        .push({ name: "StudentMain" })
        .catch((e) => {});
    },
    onGo() {
      this.isLoading = true;
      GetScheduleByStudent(this.filter).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.sched = response.data.result;
          this.gsched = this.groupping();
        } else {
          this.sched = [];
          this.gsched = [];
          if (response.data)
            this.notifyVue(
              "danger",
              response.data ? response.data : "No data found"
            );
        }
      });
    },
    groupping() {
      let list = [];
      for (let i = 0; i < this.sched.length; i++) {
        let dt = { date: this.sched[i].lessondate.substring(0, 10), items: [] };
        let pos = list
          .map(function (e) {
            return e.date;
          })
          .indexOf(dt.date);
        if (pos === -1) {
          list.push(dt);
        }
      }

      for (let i = 0; i < list.length; i++) {
        list[i].items = this.sched.filter(
          (c) => c.lessondate.substring(0, 10) === list[i].date
        );
      }
      return list;
    },
  },
  mounted() {
    this.filter.end = DateToString(new Date(this.filter.end).setDate(
      new Date(this.filter.end).getDate() + 14
    ));
    this.filter.start = DateToString(new Date());
    
    this.onGo();
  },
};
</script>

<style lang="scss" scoped>
</style>